/**
 * Friendly label formatting utilities for enum values
 * Converts SNAKE_CASE to Title Case with explicit overrides for special cases
 */

const CATEGORY_LABELS: Record<string, string> = {
  Cyber: 'Cyber',
  Physical: 'Physical',
  Personnel: 'Personnel',
  Compliance: 'Compliance',
  Facilities: 'Facilities',
  'Emergency Response': 'Emergency Response',
  'Workplace Violence': 'Workplace Violence',
  Other: 'Other',
};

const INCIDENT_STATUS_LABELS: Record<string, string> = {
  OPEN: 'Open',
  IN_PROGRESS: 'In Progress',
  RESOLVED: 'Resolved',
  CLOSED: 'Closed',
  CANCELLED: 'Cancelled',
  PENDING_CLOSURE_APPROVAL: 'Pending Closure Approval',
  REJECTED_CLOSURE: 'Closure Rejected',
};

/**
 * Converts SNAKE_CASE to Title Case
 * @param value The string to convert
 * @returns The humanized string
 */
export function humanize(value: string): string {
  if (!value) {
    return '';
  }
  return value
    .toLowerCase()
    .split('_')
    .map((word) => (word ? word[0].toUpperCase() + word.slice(1) : word))
    .join(' ');
}

/**
 * Formats investigation category with explicit labels or falls back to humanize
 * @param value The investigation category value
 * @returns The formatted label or em-dash for null/undefined
 */
export function formatInvestigationCategory(value?: string | null): string {
  if (!value) {
    return '—';
  }
  return CATEGORY_LABELS[value] ?? humanize(value);
}

/**
 * Formats incident status with explicit labels or falls back to humanize
 * @param value The incident status value
 * @returns The formatted label or em-dash for null/undefined
 */
export function formatIncidentStatus(value?: string | null): string {
  if (!value) {
    return '—';
  }
  return INCIDENT_STATUS_LABELS[value] ?? humanize(value);
}
